import React from 'react';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import strings from 'strings';
import FPIcon from 'UI/components/atoms/FPIcon';
import { SvgInformationCircle } from 'UI/res';
import { dateFormatter } from 'UI/utils';

import { StyledDivider, useStyles } from './styles';

const ITEM_TYPES = {
  dashboard: 'dashboard',
  list: 'list',
  table: 'table',
  custom: 'custom'
};

const DAILY_STATS_FOOTER_STRINGS = strings.home.sections.dailyStatsOverview.footer;

const getFormattedDate = dateLastUpdate => {
  return dateLastUpdate
    ? dateFormatter(dateLastUpdate, ({ MonthDayNumberYear }) => MonthDayNumberYear)
    : '-';
};

const getFormattedTime = dateLastUpdate => {
  return `${
    dateLastUpdate ? dateFormatter(dateLastUpdate, ({ SimpleTime }) => SimpleTime) : '-- : --'
  }`;
};

/**
 * @param {Object} props
 * @param {string} [props.bulksLastUpdate]
 * @param {string} [props.callLastUpdate]
 * @param {string} [props.externalToolsLastUpdate]
 * @param {string} props.footerActionLink
 * @param {boolean} props.shouldShowExternalToolsLabel
 * @param {boolean} props.shouldShowTitleLabel
 * @param {string} props.textLastUpdate
 * @param {string} props.type
 */
const DailyStatsFooter = ({
  bulksLastUpdate,
  callLastUpdate,
  detailText,
  externalToolsLastUpdate = '',
  footerActionLink,
  shouldShowExternalToolsLabel,
  shouldShowTitleLabel,
  textLastUpdate,
  type = ITEM_TYPES.list
}) => {
  const isTableType = type === ITEM_TYPES.table;
  const classes = useStyles();

  return (
    <>
      {!isTableType && <StyledDivider role="separator" />}
      <div className={classes.customFooterActionContainer}>
        <Grid container wrap="nowrap" className={classes.textContainer}>
          <Grid item>
            <FPIcon
              role="img"
              aria-label="Info"
              component={SvgInformationCircle}
              onSetColor={palette => palette.info.main}
              size={24}
            />
          </Grid>
          <Grid item>
            {shouldShowTitleLabel && (
              <Typography
                className={classes.customFooterActionText}
                dangerouslySetInnerHTML={{ __html: DAILY_STATS_FOOTER_STRINGS.title }}
                variant="body2"
              />
            )}
            <div className={classes.customFooterListItem}>
              {/* // TODO: Refactor component as there it is a lot of repeating code!!! This can be improved */}
              {bulksLastUpdate && (
                <Typography className={classes.customFooterActionText} variant="body2">
                  {strings.formatString(DAILY_STATS_FOOTER_STRINGS.bulks, {
                    date: getFormattedDate(bulksLastUpdate)
                  })}
                  <strong>{getFormattedTime(bulksLastUpdate)}</strong>
                </Typography>
              )}
              {callLastUpdate && (
                <Typography className={classes.customFooterActionText} variant="body2">
                  {strings.formatString(DAILY_STATS_FOOTER_STRINGS.call, {
                    date: getFormattedDate(callLastUpdate)
                  })}
                  <strong>{getFormattedTime(callLastUpdate)}</strong>
                </Typography>
              )}
              {textLastUpdate && (
                <Typography className={classes.customFooterActionText} variant="body2">
                  {strings.formatString(DAILY_STATS_FOOTER_STRINGS.text, {
                    date: getFormattedDate(textLastUpdate)
                  })}
                  <strong>{getFormattedTime(textLastUpdate)}</strong>
                </Typography>
              )}
              {shouldShowExternalToolsLabel && (
                <Typography className={classes.customFooterActionText} variant="body2">
                  {strings.formatString(DAILY_STATS_FOOTER_STRINGS.externalTools, {
                    date: getFormattedDate(externalToolsLastUpdate)
                  })}
                  <strong>{getFormattedTime(externalToolsLastUpdate)}</strong>
                </Typography>
              )}
              {detailText && (
                <Typography
                  className={classes.customFooterActionText}
                  dangerouslySetInnerHTML={{ __html: detailText }}
                  variant="body2"
                />
              )}
            </div>
            {shouldShowTitleLabel && (
              <Typography
                className={classes.customFooterActionText}
                dangerouslySetInnerHTML={{ __html: DAILY_STATS_FOOTER_STRINGS.details }}
                variant="body2"
              />
            )}
            {footerActionLink && (
              <div className={classes.footerLinkContainer}>
                <Link
                  href={footerActionLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.footerLink}
                >
                  {DAILY_STATS_FOOTER_STRINGS.phonePerformanceRules}
                </Link>
              </div>
            )}
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default DailyStatsFooter;
